"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostCoreNodeTransactionsErrorToJSON = exports.PostCoreNodeTransactionsErrorFromJSONTyped = exports.PostCoreNodeTransactionsErrorFromJSON = void 0;
function PostCoreNodeTransactionsErrorFromJSON(json) {
    return PostCoreNodeTransactionsErrorFromJSONTyped(json, false);
}
exports.PostCoreNodeTransactionsErrorFromJSON = PostCoreNodeTransactionsErrorFromJSON;
function PostCoreNodeTransactionsErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': json['error'],
        'reason': json['reason'],
        'reason_data': json['reason_data'],
        'txid': json['txid'],
    };
}
exports.PostCoreNodeTransactionsErrorFromJSONTyped = PostCoreNodeTransactionsErrorFromJSONTyped;
function PostCoreNodeTransactionsErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': value.error,
        'reason': value.reason,
        'reason_data': value.reason_data,
        'txid': value.txid,
    };
}
exports.PostCoreNodeTransactionsErrorToJSON = PostCoreNodeTransactionsErrorToJSON;
//# sourceMappingURL=PostCoreNodeTransactionsError.js.map